<div class="form">
  <form [formGroup]="editForm">
    <p class="heading" i18n>Edit</p>

    <div class="form__fields__container">
      <!-- Only Group Select -->
      <div class="group-select-container" style="margin-bottom: 1rem">
        <app-searchable-multi-select
          [label]="'Project/Group(s)'"
          [disabledOptions]="disabledGroupOptions"
          [placeholder]="groupOptions.length > 0 ? 'Select Groups' : 'No groups to remove'"
          [options]="groupOptions"
          [formControlName]="'groups'"
          [multiple]="true"
        ></app-searchable-multi-select>
      </div>
    </div>

    <div class="form__btn__container">
      <app-buttons
        [isDisabled]="false"
        [name]="buttonCancel"
        [arialLabel]="arialLabel"
        [buttonType]="btnMat"
        [buttonStyle]="btnStyleText"
        (buttonClickEvent)="closePopup()"
      ></app-buttons>

      <!-- Disable Save if form is invalid, not dirty (no changes), or currently submitting -->
      <app-buttons
        [isDisabled]="!editForm.valid || (!editForm.dirty && editForm.get('groups')?.pristine) || isSubmitting"
        [name]="buttonSave"
        [buttonType]="btnMatFlat"
        [buttonStyle]="
          !editForm.valid || (!editForm.dirty && editForm.get('groups')?.pristine) || isSubmitting
            ? btnStyleFilledSmallDisabled
            : btnStyleFilledSmall
        "
        (buttonClickEvent)="onEditSubmit()"
      ></app-buttons>
    </div>
  </form>
</div>
